"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var WirelessCartPlanState_1 = require("./WirelessCartPlanState");
var localstyles = require("./WirelessCartPlan.scss");
var wirelessStyles = require("../WirelessCart.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var cartUtils = require("../../../../utils/CartUtilFunctions");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var CartItemPromo_1 = require("../../../atoms/CartItemPromo");
var ReportingService_1 = require("../../../../api/ReportingService");
var components_1 = require("@idp/duc/components");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
/**
 * Presentational component for Wireless Plan in Wireless Flow.
 * This renders UI based on data available in statemanager.
 *
 * @export
 * @class WirelessCartPlan
 * @extends {React.Component<WirelessCartPlanProps, WirelessCartPlanState>}
 */
var WirelessCartPlan = /** @class */ (function (_super) {
    __extends(WirelessCartPlan, _super);
    function WirelessCartPlan(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new WirelessCartPlanState_1.default();
        _this.bindFunctions();
        _this.wirelessCartCMS = wlsUtils.getWlsCmsData();
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    WirelessCartPlan.prototype.bindFunctions = function () {
        this.renderPlanSection = this.renderPlanSection.bind(this);
        this.getPlanDetails = this.getPlanDetails.bind(this);
        this.openPlanDetailsModal = this.openPlanDetailsModal.bind(this);
        this.renderPlanDetailsModal = this.renderPlanDetailsModal.bind(this);
        this.closePlanDetailsModal = this.closePlanDetailsModal.bind(this);
        this.renderPlanPromotion = this.renderPlanPromotion.bind(this);
        this.renderAccessFees = this.renderAccessFees.bind(this);
        this.getAccessFeeDetails = this.getAccessFeeDetails.bind(this);
        this.sortAccessFees = this.sortAccessFees.bind(this);
        this.lineItemHasABPPromo = this.lineItemHasABPPromo.bind(this);
        this.renderRatePlanDisclaimer = this.renderRatePlanDisclaimer.bind(this);
        this.getRatePlanMessage = this.getRatePlanMessage.bind(this);
    };
    WirelessCartPlan.prototype.render = function () {
        return (this.renderPlanSection());
    };
    WirelessCartPlan.prototype.renderPlanSection = function () {
        var _a;
        var planDetails = this.getPlanDetails();
        var accessFeeDetails = this.getAccessFeeDetails();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: [wirelessStyles.lineItems,
                    wirelessStyles.lineItemContainer].join(' ') },
                React.createElement(ui_components_1.Label, { data: {
                        isDecodingRequired: true,
                        text: planDetails.planName,
                    }, options: { className: wirelessStyles.itemName } }),
                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: {
                        billingNote: this.props.data.expressView ? '' : '/mo.',
                        price: planDetails.grandTotal,
                    }, options: {
                        className: wirelessStyles.lineItem,
                        decimalPoints: 2,
                        type: PriceContainerProps_1.PricingType.XSMALL,
                    } })),
            React.createElement("div", { className: [
                    wirelessStyles.monthlyPayments
                ].join(' '), id: utils_1.default('WRLS', 'Plan', 'SubtextDetails') },
                accessFeeDetails.count === 1 && this.wirelessCartCMS.deviceCountOneLabel,
                accessFeeDetails.count > 1 &&
                    this.wirelessCartCMS.deviceCountLabel &&
                    this.wirelessCartCMS.deviceCountLabel.replace('{0}', (_a = accessFeeDetails.count) === null || _a === void 0 ? void 0 : _a.toString()),
                React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('See', 'Plan', 'Breakdown'), className: localstyles.planLinkStyles, onClick: this.openPlanDetailsModal }, this.wirelessCartCMS.priceBreakdownModalLink || 'See price details with discounts'),
                this.renderRatePlanDisclaimer()),
            this.renderPlanDetailsModal()));
    };
    WirelessCartPlan.prototype.renderPlanDetailsModal = function () {
        var planDetails = this.getPlanDetails();
        var accessFeeDetails = this.getAccessFeeDetails();
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('Plan', 'Details', 'Modal'), options: {
                center: true,
                className: {
                    modalParentClass: localstyles.modalParent,
                },
                show: this.state.showPlanDetailsModal,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
                tabIndex: 0,
            }, events: { onClose: this.closePlanDetailsModal } },
            React.createElement("div", { className: [localstyles.modalBody].join(' ') },
                React.createElement("div", null,
                    React.createElement(ui_components_1.Label, { data: { text: planDetails.planName }, options: {
                            className: localstyles.modalHeading,
                            size: LabelProps_1.LabelSizes.MEDIUMHEADING,
                            tag: LabelProps_1.LabelTags.h1,
                        } })),
                React.createElement(ui_components_1.Label, { data: { text: this.wirelessCartCMS.planModaldescription }, options: { className: localstyles.planModalDescription } }),
                React.createElement("div", { className: [wirelessStyles.lineItems,
                        wirelessStyles.lineItemContainer, localstyles.planModalLineItems].join(' ') },
                    React.createElement(ui_components_1.Label, { data: {
                            isDecodingRequired: true,
                            text: this.wirelessCartCMS.planChargeLabel,
                        }, options: { className: wirelessStyles.itemName } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: {
                            price: planDetails.planTotalPrice,
                        }, options: {
                            className: wirelessStyles.lineItem,
                            decimalPoints: 2,
                            type: PriceContainerProps_1.PricingType.XSMALL,
                        } })),
                this.renderPlanPromotion(planDetails.promotionsArray),
                React.createElement("div", { className: [wirelessStyles.lineItems,
                        wirelessStyles.lineItemContainer,
                        localstyles.planModalLineItems,
                        localstyles.planModaltotalsDiv].join(' ') },
                    React.createElement(ui_components_1.Label, { data: {
                            isDecodingRequired: true,
                            text: this.wirelessCartCMS.planChargetotalLabel,
                        }, options: { className: [wirelessStyles.itemName, localstyles.planModaltotalsLineItem].join(' ') } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: {
                            price: planDetails.planDiscountedPrice,
                        }, options: {
                            className: wirelessStyles.lineItem,
                            decimalPoints: 2,
                            type: PriceContainerProps_1.PricingType.XSMALL,
                        } })),
                React.createElement("div", { className: [localstyles.dottedLine, localstyles.planModalLineItems].join(' ') }),
                this.renderAccessFees(),
                React.createElement("div", { className: [wirelessStyles.lineItems,
                        wirelessStyles.lineItemContainer,
                        localstyles.planModalLineItems,
                        localstyles.planModaltotalsDiv].join(' ') },
                    React.createElement(ui_components_1.Label, { data: {
                            isDecodingRequired: true,
                            text: this.wirelessCartCMS.deviceChargetotalLabel,
                        }, options: { className: [wirelessStyles.itemName,
                                localstyles.planModaltotalsLineItem].join(' ') } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: {
                            price: accessFeeDetails.accessFeeDiscoutedPrice,
                        }, options: {
                            className: wirelessStyles.lineItem,
                            decimalPoints: 2,
                            type: PriceContainerProps_1.PricingType.XSMALL,
                        } })),
                React.createElement("div", { className: [localstyles.solidLine, localstyles.planModalLineItems].join(' ') }),
                React.createElement("div", { className: [wirelessStyles.lineItems,
                        wirelessStyles.lineItemContainer,
                        localstyles.planModalLineItems,
                        localstyles.planModaltotalsDiv].join(' ') },
                    React.createElement(ui_components_1.Label, { data: {
                            isDecodingRequired: true,
                            text: this.wirelessCartCMS.grandtotalLabel,
                        }, options: { className: [wirelessStyles.itemName,
                                localstyles.planModaltotalsLineItem].join(' ') } }),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: {
                            price: planDetails.grandTotal,
                        }, options: {
                            className: wirelessStyles.lineItem,
                            decimalPoints: 2,
                            type: PriceContainerProps_1.PricingType.XSMALL,
                        } })),
                React.createElement("div", { className: [localstyles.planModalAlignCenter].join(' ') },
                    React.createElement(ui_components_1.Label, { data: {
                            isDecodingRequired: true,
                            text: this.wirelessCartCMS.planModalFooterMessage,
                        }, options: { className: localstyles.planModalFooterMessage } })))));
    };
    WirelessCartPlan.prototype.renderPlanPromotion = function (planPromotions) {
        var _this = this;
        var payload = cartUtils.getWirelessCart();
        var wirelessPromotions = this.props.data && this.props.data.wirelessCartData
            && this.props.data.wirelessCartData.promotions ? this.props.data.wirelessCartData.promotions : [];
        if (planPromotions && wirelessPromotions) {
            return planPromotions.map(function (planPromo) {
                return wirelessPromotions.map(function (wirelessPromo, index) {
                    var _a;
                    var promoDisplayName = wirelessPromo.promotionName;
                    if (wirelessPromo && wirelessPromo.promotionCategory && wirelessPromo.promotionCategory === 'ABPDiscount'
                        && wirelessPromo.phonesCount && wirelessPromo.alternativePromotionName) {
                        var abpContent = _this.wirelessCartCMS.abpDiscountLable || '';
                        promoDisplayName = abpContent.replace('{0}', String(wirelessPromo.phonesCount));
                    }
                    if (planPromo === wirelessPromo.id) {
                        return (React.createElement(React.Fragment, { key: index },
                            React.createElement("div", { id: "promo_" + wirelessPromo.id, className: [localstyles.planModalLineItems].join(' ') },
                                React.createElement(CartItemPromo_1.default, { data: {
                                        isPriceNegative: true,
                                        isSignaturePromo: (payload === null || payload === void 0 ? void 0 : payload.enableSignatureEnhancedExperience) &&
                                            ((wirelessPromo === null || wirelessPromo === void 0 ? void 0 : wirelessPromo.promotionCategory) === 'iruPlanDiscount'
                                                || ((_a = wirelessPromo === null || wirelessPromo === void 0 ? void 0 : wirelessPromo.discountCategory) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'noncontractual'),
                                        promoPrice: wirelessPromo.amount,
                                        promoText: promoDisplayName,
                                        showPrice: Number(wirelessPromo.amount) > 0,
                                    }, options: { testId: utils_1.default('WLS', 'Plan', 'Promotion') } }),
                                _this.props.events.getLegalLink(wirelessPromo.atgPromotionId, wirelessPromo.promotionId))));
                    }
                    else {
                        return (React.createElement(React.Fragment, null));
                    }
                });
            });
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    WirelessCartPlan.prototype.renderAccessFees = function () {
        var _this = this;
        if (this.props.data && this.props.data.wirelessCartData &&
            this.props.data.wirelessCartData.planModalDetails &&
            this.props.data.wirelessCartData.planModalDetails.accesschargeItems) {
            var accessFeeLineItems = Object.values(this.props.data.wirelessCartData.planModalDetails.accesschargeItems);
            return accessFeeLineItems.sort(this.sortAccessFees).map(function (accessFeeLineItem, index) {
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement("div", { className: [wirelessStyles.lineItems,
                            wirelessStyles.lineItemContainer, localstyles.planModalLineItems].join(' ') },
                        React.createElement(ui_components_1.Label, { data: {
                                isDecodingRequired: true,
                                text: _this.wirelessCartCMS.shareFeatureLabel,
                            }, options: { className: wirelessStyles.itemName } }),
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: {
                                price: accessFeeLineItem.price.baseAmount,
                            }, options: {
                                className: wirelessStyles.lineItem,
                                decimalPoints: 2,
                                type: PriceContainerProps_1.PricingType.XSMALL,
                            } })),
                    _this.renderPlanPromotion(accessFeeLineItem.promotionReferences)));
            });
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    WirelessCartPlan.prototype.renderRatePlanDisclaimer = function () {
        if (cartUtils.isSharedRetrievedCart()) {
            return (React.createElement("div", { className: [
                    wirelessStyles.monthlyPayments, localstyles.ratePlanDisclaimerMsg
                ].join(' '), tabIndex: 0, id: utils_1.default('WRLS', 'Rateplan', 'disclaimer') }, this.getRatePlanMessage()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessCartPlan.prototype.getRatePlanMessage = function () {
        if (this.props.data && this.props.data.wirelessCartData &&
            this.props.data.wirelessCartData.planModalDetails &&
            this.props.data.wirelessCartData.planModalDetails.planlineItems) {
            var planLineItem = Object.values(this.props.data.wirelessCartData.planModalDetails.planlineItems)[0];
            if (planLineItem) {
                var planBillingCode = planLineItem.billingCode;
                var ratePlanDisclaimerMessageTxt = '';
                if (this.wirelessCartCMS.ratePlanDisclaimerMessage &&
                    this.wirelessCartCMS.ratePlanDisclaimerMessage[planBillingCode]) {
                    ratePlanDisclaimerMessageTxt = this.wirelessCartCMS.ratePlanDisclaimerMessage[planBillingCode];
                }
                return ratePlanDisclaimerMessageTxt;
            }
        }
        return '';
    };
    WirelessCartPlan.prototype.getPlanDetails = function () {
        var _this = this;
        var planDetails = {
            grandTotal: 0.00,
            planDiscountedPrice: 0.00,
            planName: '',
            planTotalPrice: 0.00,
            promotionsArray: [],
        };
        if (this.props.data && this.props.data.wirelessCartData &&
            this.props.data.wirelessCartData.planModalDetails &&
            this.props.data.wirelessCartData.planModalDetails) {
            planDetails.grandTotal = Number(this.props.data.wirelessCartData.planModalDetails.grandTotal);
            planDetails.planDiscountedPrice = Number(this.props.data.wirelessCartData.planModalDetails.planTotal);
        }
        if (this.props.data && this.props.data.wirelessCartData &&
            this.props.data.wirelessCartData.planModalDetails &&
            this.props.data.wirelessCartData.planModalDetails.planlineItems) {
            Object.keys(this.props.data.wirelessCartData.planModalDetails.planlineItems).forEach(function (planKey) {
                var planInfo = _this.props.data.wirelessCartData.
                    planModalDetails.planlineItems[planKey];
                planDetails.planName = planInfo.displayName;
                if (planInfo && planInfo.price) {
                    planDetails.planTotalPrice = Number(planInfo.price.baseAmount);
                }
                if (planInfo && planInfo.promotionReferences) {
                    planDetails.promotionsArray = planDetails.promotionsArray.concat(planInfo.promotionReferences);
                }
            });
        }
        return planDetails;
    };
    WirelessCartPlan.prototype.getAccessFeeDetails = function () {
        var accessFeeDetails = {
            accessFeeDiscoutedPrice: 0.00,
            count: 0,
        };
        if (this.props.data && this.props.data.wirelessCartData &&
            this.props.data.wirelessCartData.planModalDetails &&
            this.props.data.wirelessCartData.planModalDetails.accesschargeItems) {
            accessFeeDetails.accessFeeDiscoutedPrice =
                Number(this.props.data.wirelessCartData.planModalDetails.accessChargeTotal);
            accessFeeDetails.count =
                Object.values(this.props.data.wirelessCartData.planModalDetails.accesschargeItems).length;
        }
        return accessFeeDetails;
    };
    WirelessCartPlan.prototype.openPlanDetailsModal = function () {
        this.setState({ showPlanDetailsModal: true });
        this.reportingService.
            fireLinkClickThenPageloadEvent(this.wirelessCartCMS.priceBreakdownModalLink, ReportingService_1.PageUrls.WIRELESS_PLAN_MODAL);
    };
    WirelessCartPlan.prototype.closePlanDetailsModal = function () {
        this.setState({ showPlanDetailsModal: false });
        this.reportingService.
            fireLinkClickThenPageloadEvent('close', ReportingService_1.PageUrls.CART);
    };
    WirelessCartPlan.prototype.sortAccessFees = function (accessFeeA, accessFeeB) {
        if (accessFeeA && accessFeeB) {
            if (accessFeeA.promotionReferences && accessFeeA.promotionReferences.length &&
                this.lineItemHasABPPromo(accessFeeA)) {
                return 1;
            }
            else if (accessFeeB.promotionReferences && accessFeeB.promotionReferences.length &&
                this.lineItemHasABPPromo(accessFeeB)) {
                return -1;
            }
            else {
                return 0;
            }
        }
        return 0;
    };
    WirelessCartPlan.prototype.lineItemHasABPPromo = function (lineItem) {
        var wirelessPromotions = this.props.data && this.props.data.wirelessCartData
            && this.props.data.wirelessCartData.promotions ? this.props.data.wirelessCartData.promotions : [];
        var promoKeys = lineItem.promotionReferences;
        if (wirelessPromotions && promoKeys && wirelessPromotions.length && promoKeys.length) {
            for (var _i = 0, wirelessPromotions_1 = wirelessPromotions; _i < wirelessPromotions_1.length; _i++) {
                var promo = wirelessPromotions_1[_i];
                if (promoKeys.includes(promo.id)
                    && promo.promotionCategory && promo.promotionCategory === 'ABPDiscount') {
                    return true;
                }
            }
            return false;
        }
        return false;
    };
    return WirelessCartPlan;
}(React.Component));
exports.default = WirelessCartPlan;
//# sourceMappingURL=WirelessCartPlan.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessCartPlan/WirelessCartPlan.js
// module id = 2283
// module chunks = 8